import { Box, Radio, RadioGroup, FormControlLabel } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { ButtonHot, BUTTON_MODE } from 'components/common/ButtonHot';
import { useSelector } from 'react-redux';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';
export const ReasonContent = ({ selectedReason, onReasonChange, onReasonTextChange, onSubmit, testID, isMobile }) => {
  const { couponsCancellationReasons } = useSelector((store) => store.config.Parameters);
  const { translate } = useTranslations();
  return (
    <Box
      testId={generateTestId(testID, 'content')}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <TextHot
        testID={generateTestId(testID, 'title')}
        size="xxl"
        bold="bold"
        color="primary"
        isLtr={true}
        sx={{ marginBottom: `${spacing.sm}px`, textAlign: 'center' }}
      >
        {translate('cancel_modal_title')}
      </TextHot>

      <TextHot
        testID={generateTestId(testID, 'subtitle')}
        size="l"
        color="subtle"
        isLtr={true}
        sx={{ marginBottom: `${spacing.xl}px`, textAlign: 'center' }}
      >
        {translate('cancel_modal_description')}
      </TextHot>

      <Box
        testId={generateTestId(testID, 'radio-group')}
        sx={{
          marginBottom: `${spacing.xl}px`,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          gap: `${spacing.sm}px`,
        }}
      >
        <RadioGroup
          value={selectedReason ?? ''}
          onChange={(event) => {
            const reason = couponsCancellationReasons?.find((r) => String(r.id) === String(event.target.value));
            onReasonChange(reason?.id ?? '');
            onReasonTextChange(reason?.text ?? '');
          }}
          sx={{ width: '100%' }}
        >
          {couponsCancellationReasons?.map((reason) => (
            <FormControlLabel
              key={reason.id}
              testId={generateTestId(testID, `option-${reason.id}`)}
              control={
                <Radio
                  testId={generateTestId(testID, `radio-${reason.id}`)}
                  value={reason.id}
                  sx={{
                    color: colors.system.border.default,
                    '&.Mui-checked': { color: colors.system.brand.primary },
                  }}
                />
              }
              label={
                <TextHot testID={generateTestId(testID, `label-${reason.id}`)} size="l" color="primary">
                  {reason.text}
                </TextHot>
              }
              labelPlacement="end"
              sx={{
                marginRight: 0,
                marginLeft: 0,
                width: '100%',
                justifyContent: 'flex-start',
                flexDirection: 'row',
              }}
            />
          ))}
        </RadioGroup>
      </Box>

      <ButtonHot
        testID={generateTestId(testID, 'submit-btn')}
        mode={BUTTON_MODE.OUTLINED}
        onClick={onSubmit}
        disabled={!selectedReason}
        sx={{
          width: isMobile ? '100%' : 'auto',
          minWidth: isMobile ? 'auto' : 144,
          maxWidth: isMobile ? '100%' : 144,
          alignSelf:  'center',
          borderRadius: `${radius.xl}px`,
          padding: `${spacing.md}px ${spacing.xl}px`,
          border: `1px solid ${colors.system.border.default}`,
          color: colors.system.text.primary,
          marginBottom: `${spacing.lg}px`,
        }}
      >
        {translate('cancel_modal_button_text')}
      </ButtonHot>

      <TextHot
        testID={generateTestId(testID, 'footer')}
        size="s"
        color="subtle"
        isLtr={true}
        sx={{ textAlign: 'left', lineHeight: 1.5 }}
      >
        {translate('modal_disclaimer_text')}
      </TextHot>
    </Box>
  );
};